import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('PackageDayService', PackageDayService);

  PackageDayService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'WindowModalService',
    'ModalWindowConfirmService',
  ];

  function PackageDayService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    WindowModalService,
    ModalWindowConfirmService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'packages';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getPackageDays: getPackageDays,
      reorderPackageDays: reorderPackageDays,
      getPackageDay: getPackageDay,
      savePackageDay: savePackageDay,
      openPackageDayDetailModal: openPackageDayDetailModal,
      deletePackageDay: deletePackageDay,
      changePackageDayStatus: changePackageDayStatus,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'day_number',
      };

      return filterCriteria;
    }

    function getPackageDays(packageId, filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      var url = apiUrl + '/' + packageId + '/package_days';

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function reorderPackageDays(days, packageId, successCallback) {
      var modalParams = {
        mode: 'danger',
        title: 'SURE_TO_UPDATE_ITINERARY_ORDER',
        body: 'SURE_TO_UPDATE_ITINERARY_ORDER_WARNING',
        preventModalClose: true,
      };

      var confirmCallback = function () {
        var packageDaysOrder = [];
        days.forEach(function (day, index) {
          day.day_number = index + 1;

          packageDaysOrder.push({
            id: day.id,
            day_number: day.day_number,
          });
        });

        // console.log(packageDaysOrder); return;

        function success() {
          utils._successMsg($translate('ITINERARY_UPDATED'));

          return successCallback(days);
        }
        function failure() {}

        var url = apiUrl + '/' + packageId + '/package_days/reorder_items';

        return RestResource.request('put', url, { items: packageDaysOrder }, success, failure);
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback);
    }

    function getPackageDay(roomId, packageId, language) {
      var params = { lang: null };

      if (language) {
        params.lang = language;
      }

      var url = apiUrl + '/' + packageId + '/package_days/' + roomId;

      return RestResource.request(
        'get',
        url,
        params,
        function (response) {
          response.data.logoUrl = utils.cleanItemCache(response.data, 'logo');
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function savePackageDay(item, packageId) {
      var itemAddedMsg = $translate('DAY_ADDED');
      var itemModifiedMsg = $translate('DAY_MODIFIED');

      var method;
      var url = apiUrl + '/' + packageId + '/package_days';
      if (!item.id) {
        // create
        method = 'post';
      } else {
        method = 'put';
        url = url + '/' + item.id;
      }

      function success(response) {
        var msg = item.id ? itemModifiedMsg : itemAddedMsg;
        utils._successMsg(msg);

        return response.data;
      }
      function failure(response) {
        return response.data;
      }

      return RestResource.request(method, url, { package_day: item }, success, failure);
    }

    function deletePackageDay(item, packageId, successCallback) {
      var params = {
        title: 'SURE_TO_DELETE_DAY',
        // itemName:    item.day_number,
        body: 'SURE_TO_DELETE_DAY_WARNING',
        // reason:     'DELETE_ITEM_REASON',
        successMsg: 'DAY_DELETED',
      };

      var url = apiUrl + '/' + packageId + '/package_days/' + item.id;
      utils.deleteItem(url, successCallback, params);
    }

    function changePackageDayStatus(item, packageId) {
      var params = {
        body: 'SURE_TO_DEACTIVATE_DAY_WARNING',
      };

      utils.changeItemStatus(apiUrl + '/' + packageId + '/package_days/' + item.id, item, params);
    }

    function openPackageDayDetailModal(item, mode, defaultLanguage, pack, successCallback) {
      var templateUrl = './app/ajs/package-days/modals/package-day-detail-modal.html';

      var originalItem = angular.copy(item);

      var modalParams = {
        title: 'DAY_DETAILS',
        item: originalItem,
        mode: mode,
        parentOptions: pack,
        defaultLanguage: defaultLanguage,
        preventModalClose: true,
      };

      // onSavedItem in modal service
      var confirmCallback = function (day) {
        if (item.id) {
          // Edit
          item.name = day.name;
          item.meals_included = day.meals_included;
          item.location_id = day.location_id;
          item.location = day.location;
          item.hotel_room_ids = day.hotel_room_ids;
          item.hotel_rooms = day.hotel_rooms;
          item.tour_option_schedule_ids = day.tour_option_schedule_ids;
          item.tour_option_schedules = day.tour_option_schedules;
          item.transportation_schedule_ids = day.transportation_schedule_ids;
          item.transportation_schedules = day.transportation_schedules;
          item.service_item_ids = day.service_item_ids;
          item.service_items = day.service_items;
          item.facility_ids = day.facility_ids;
          item.what_to_bring_ids = day.what_to_bring_ids;

          return utils.itemListChanged(day.id);
        }

        // create
        item = angular.copy(day);
        utils.itemListChanged(item.id);

        return successCallback(item);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }
  }
})();
